import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { ExperimentIdentifier } from '../ExperimentIdentifier';
import { ExperimentKeys } from '../ExperimentKeys';
import { getUserExperimentIdentifier } from '../getUserExperimentIdentifier';
import { getIsNewUser } from '../../store/app/selectors';
import { ExperimentActionTypes } from '../../store/experiments/action-types';
import { arePreAccountCreatedExperimentsFetched } from '../../store/experiments/selectors';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { hasTrackingBeenEnabled } from '../../tracking/trackingUtils';
import { useTrackSignupInitiated } from '../../tracking/useTrackSignupInitiated';
import { ACQ111_WEBSITE_TREATMENT_QUERY_PARAM, getIsEnrolledForACQ111, isACQ111WebsiteVariant } from './acq111Utils';
import { getQueryParam } from '../../routing/getQueryParam';
import { useTracker } from '../../tracking/useTracker';
const ACQ111_PROMPT_DISMISSED_QUERY_PARAM = 'prompt-dismissed';
const ACQ111_PROMPT_CLICKED_QUERY_PARAM = 'prompt-clicked';
let hasExposureBeenTrackedACQ111Cache = false;
export function getHasExposureBeenTrackedACQ111() {
  return hasExposureBeenTrackedACQ111Cache;
}
export function setHasExposureBeenTrackedACQ111() {
  hasExposureBeenTrackedACQ111Cache = true;
}
export function resetExposureForACQ111() {
  hasExposureBeenTrackedACQ111Cache = false;
}

const updateExperimentACQ111InState = () => dispatch => {
  const experimentIdentifier = getUserExperimentIdentifier();
  const acq111WebsiteTreatment = getQueryParam(ACQ111_WEBSITE_TREATMENT_QUERY_PARAM);
  dispatch({
    type: ExperimentActionTypes.BulkUpdateExperiments,
    response: {
      [ExperimentKeys.ACQ111]: {
        key: ExperimentKeys.ACQ111,
        identifier: experimentIdentifier,
        status: {
          isActive: true,
          isEnrolled: true,
          isDefaulted: false,
          isCached: false
        },
        parameters: {
          group: acq111WebsiteTreatment
        },
        maxAge: 0,
        trackedExposure: true
      }
    },
    identifierPhase: ExperimentIdentifier.Utk
  });
};

export const trackExposureACQ111 = treatment => {
  setHasExposureBeenTrackedACQ111();
  getTracker().track(EventName.ExperimentExposure, {
    action: `${ExperimentKeys.ACQ111}-group-${treatment}`
  }, true);
};

const getPromptDismissedValue = () => {
  const isVariant = isACQ111WebsiteVariant();
  const promptDismissedValue = isVariant ? parseInt(getQueryParam(ACQ111_PROMPT_DISMISSED_QUERY_PARAM), 10) : NaN;
  return promptDismissedValue;
};

const getPromptClickedValue = () => {
  const isVariant = isACQ111WebsiteVariant();
  const promptClickedValue = isVariant ? parseInt(getQueryParam(ACQ111_PROMPT_CLICKED_QUERY_PARAM), 10) : NaN;
  return promptClickedValue;
};

export const useWebsiteExperimentACQ111 = () => {
  const dispatch = useAppDispatch();
  const experimentsFetched = useSelector(arePreAccountCreatedExperimentsFetched);
  const trackingEnabled = hasTrackingBeenEnabled();
  const isNewUser = useSelector(getIsNewUser);
  const Tracker = useTracker();
  useTrackSignupInitiated(isNewUser);
  useEffect(() => {
    const acq111WebsiteTreatment = getQueryParam(ACQ111_WEBSITE_TREATMENT_QUERY_PARAM);
    const isEnrolledForACQ111 = getIsEnrolledForACQ111();
    const exposureHasBeenTracked = getHasExposureBeenTrackedACQ111();

    if (trackingEnabled && isEnrolledForACQ111 && experimentsFetched) {
      if (!exposureHasBeenTracked) {
        trackExposureACQ111(acq111WebsiteTreatment);
        dispatch(updateExperimentACQ111InState());
        const promptDismissedValue = getPromptDismissedValue();
        const promptClickedValue = getPromptClickedValue();

        if (!isNaN(promptDismissedValue)) {
          Tracker.signupInteraction('prompt-dismissed');
        }

        if (!isNaN(promptClickedValue)) {
          Tracker.signupInteraction(promptClickedValue ? 'prompt-clicked' : 'prompt-not-clicked');
        }
      }
    }
  }, [dispatch, trackingEnabled, experimentsFetched, Tracker]);
};
export const checkIfIsACQ111AndExposureTracked = activeExperimentId => {
  return activeExperimentId === ExperimentKeys.ACQ111 && getHasExposureBeenTrackedACQ111();
};